module.exports = __webpack_public_path__ + "static/media/archery05.930344f1.jpg";